<template>
  <section id="about" class="cr-section about-area section-padding-sm "  >
    <Loading :loaded="loaded"></Loading>
    <div class="container">
      <h2 >{{$t('A csapat')}}</h2>
      <div class="row align-items-start align-items-xl-center" >
        <div class="col-md-4 col-12" v-for="(member,index) in members" v-bind:key="'member-'+index" >
          <div class="about-image m-5">
            <ImageLazy :image="member.image" :title="member.name" :alt="member.position"></ImageLazy>
          </div>
          <div class="about-content textblock text-center">
            <h4>{{member.name}}</h4>
            <h5>{{member.position}}</h5>
            <p>{{member.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ImageLazy from './ImageLazy'
import Loading from './Loading'

export default {
  name: 'About',
  components: {ImageLazy, Loading},
  data () {
    return {
      loaded: false,
      members: []
    }
  },
  mounted () {
    this.getSlides()
    const self = this
    self.$eventHub.$on('language-changed', function () {
      self.getSlides()
    })
  },
  methods: {
    getSlides ($event) {
      this.axios.get(this.$host + 'members').then(resp => {
        this.members = resp.data.data
        this.loaded = true
      }).catch(() => { this.loaded = true })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/About.vue